import { useContext, useMemo } from 'react';

import { useWorkloadGpuMetricsQuery } from 'hooks/queries/workload-optimization';

import { useRightsizingTimeRangeSelection } from '../../../../../_hooks/useRightsizingTimeRangeSelection';
import { TimeRangeSelection } from '../../../../../_hooks/useCurrentWorkloadMetrics';
import { WorkloadDetailsContext } from '../../../../_context';
import { normalizeGpuData } from '../../../_utils/normalizeGpuData';
import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useGpuMetricsData = ({
  timeRangeSelection,
}: {
  timeRangeSelection?: TimeRangeSelection;
} = {}) => {
  const { workload } = useContext(WorkloadDetailsContext);
  const { cluster } = useCluster();
  const rightsizingTimeRangeSelection = useRightsizingTimeRangeSelection();
  const { getRange, key } = timeRangeSelection ?? rightsizingTimeRangeSelection;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const range = useMemo(() => getRange(), [key]);

  const { data, isLoading, isFetching, error, refetch } =
    useWorkloadGpuMetricsQuery({
      clusterId: cluster.id,
      workloadId: workload?.id ?? '',
      from: range.from ?? '',
      to: range.to ?? '',
      enabled: !!workload,
    });

  const normalized = useMemo(
    () => (data ? normalizeGpuData(data) : null),
    [data]
  );

  return { normalized, isLoading, isFetching, error, refetch, workload };
};
